module.exports = __webpack_public_path__ + "static/sui-table-cell-highlight-f9dd257bb6b6ab5315c5b9b2959bd539.png";